(window.MyModule = function ($, Behaviors) {

    "use strict";

    var module = {};

    function OEProductAccessories(elem) {
        Behaviors.init(OEProductAccessories, this, arguments);

        var $thisElem = this.$elem,
            slider = $thisElem.find('.OEProductAccessories-list--slider'),
            sliderAlt = $thisElem.find('.OEProductAccessories-list--slider-alt');

        slider.slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<span class="slick-prev"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 12H5m0 0 7-7m-7 7 7 7" stroke="#009" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>',
            nextArrow: '<span class="slick-next"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 12h14m0 0-7-7m7 7-7 7" stroke="#009" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>',
            variableWidth: true,
            appendArrows: $thisElem.find('.OEProductAccessories-list--slider-nav'),
            responsive: [
                {
                    breakpoint: 1620,
                    settings: {
                    }
                },
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 4,
                        arrows: false,
                        dots: true,
                        appendDots: $thisElem.find('.OEProductAccessories-list--slider-nav'),
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                        arrows: false,
                        dots: true,
                        appendDots: $thisElem.find('.OEProductAccessories-list--slider-nav')
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        arrows: false,
                        dots: true,
                        appendDots: $thisElem.find('.OEProductAccessories-list--slider-nav')
                    }
                }
            ]
        });

        sliderAlt.slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<span class="slick-prev"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 12H5m0 0 7-7m-7 7 7 7" stroke="#009" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>',
            nextArrow: '<span class="slick-next"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 12h14m0 0-7-7m7 7-7 7" stroke="#009" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>',
            variableWidth: true,
            appendArrows: $thisElem.find('.OEProductAccessories-list--slider-nav'),
            responsive: [
                {
                    breakpoint: 1620,
                    settings: {
                    }
                },
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 4,
                        arrows: false,
                        dots: true,
                        appendDots: $thisElem.find('.OEProductAccessories-list--slider-nav'),
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                        arrows: false,
                        dots: true,
                        appendDots: $thisElem.find('.OEProductAccessories-list--slider-nav')
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        arrows: false,
                        dots: true,
                        appendDots: $thisElem.find('.OEProductAccessories-list--slider-nav')
                    }
                }
            ]
        });

    }

    Behaviors.inherit(OEProductAccessories, Behaviors.Behavior);

    OEProductAccessories.QUERY = "[data-oeproduct-accessories]";

    Behaviors.register_behavior(OEProductAccessories);

    module.OEProductAccessories = OEProductAccessories;

    return module;

}(window.jQuery, window.Behaviors));